import { render } from "./App.vue?vue&type=template&id=14c48e53"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=14c48e53&lang=scss"

import exportComponent from "/home/runner/work/MMXD_CardOptimizer/MMXD_CardOptimizer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__